import { render, staticRenderFns } from "./InfoComp.vue?vue&type=template&id=a60dcc38&scoped=true&"
import script from "./InfoComp.vue?vue&type=script&lang=js&"
export * from "./InfoComp.vue?vue&type=script&lang=js&"
import style0 from "./InfoComp.vue?vue&type=style&index=0&id=a60dcc38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60dcc38",
  null
  
)

export default component.exports